import {
	InsuredInfo,
	Mortgagee,
	PerilDeductible,
} from '@app/models/api';

export default class EndorsementResponsePolicy {

	public deductibles: PerilDeductible[] | null = null;
	public namedInsured: InsuredInfo | null = null;
	public mortgagees: Mortgagee[] = [];

	public constructor() {

	}
}